// Attributes which may not be mutated on controlled iframes because they either
// affect security or could cause the iframe's document to change. Due to
// TypeScript limitations, we unfortunately need to define these at both the
// type and value level right now. (String enums don't work with the conditional
// type restrictions we want to apply using UnrestrictedAttr.)
// TODO(sethf): We should probably make use of these ourselves a bit more. In
// particular, it'd be good to apply feature policies via 'allow' or the
// 'Feature-Policy' header. So many security mechanisms...
export type RestrictedAttr = 'allow' |
  'allowfullscreen' |
  'allowpaymentrequest' |
  'allowusermedia' |
  'sandbox' |
  'src' |
  'srcdoc';
export const RestrictedAttrValues: RestrictedAttr[] = [
  'allow',
  'allowfullscreen',
  'allowpaymentrequest',
  'allowusermedia',
  'sandbox',
  'src',
  'srcdoc',
];

// A type containing attribute names which *aren't* restricted.
export type UnrestrictedAttr<Attr> = Attr & (Attr extends RestrictedAttr ? never : string);
